import { initBotId } from 'botid/client/core'

/**
 * BotID client protect list — ONLY public, browser-submitted form endpoints.
 *
 * Intentionally NOT listed (must keep working for cron/external/server callers):
 * - /api/clients/** — including the DTH hiring widget, which is served in a
 *   cross-site iframe on the client's own domain where the challenge is not
 *   reliable and was denying real applicants
 * - /api/stripe/webhook
 * - /api/webhooks/**
 * - /api/auth/**
 * - /api/agency/**
 * - CMS/admin/internal APIs
 */
initBotId({
  protect: [
    { path: '/api/form-notification', method: 'POST' },
    { path: '/api/contact/feedback', method: 'POST' },
    { path: '/api/resources/newsletter-subscribe', method: 'POST' },
  ],
})
